// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img{max-width:100%}@media(max-width:500px){.data-text{flex-direction:column}.q-btn--rounded .block{padding-left:50px;padding-right:50px}}", ""]);
// Exports
module.exports = exports;
